import { useState, useEffect } from "react"
import { ReminderPageWrapper } from "../../../../-components/reminders/ReminderPageWrapper"
import { TextProps, Text } from "@mantine/core"
import { useRouter } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { DetailsTabs } from "../../../-components/details-tabs"
import { ProductionTitleText } from "../../../-components/production-title"
import { Page } from "../../../../../-components/Page"
import { useGetNewReminderMenuItemProps } from "@components/useGetNewReminderMenuItemProps"
import { useGetReminderListMenuItemProps } from "@components/useGetReminderListMenuItemProps"
import { DateOnly } from "../../../../../@client/System"
import { useQueryGet } from "../../../../../typed-client/hooks/use-query-get"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { dateToTimeOnly } from "../../../../../utils/date-to-time-only"
import { getFormattedDate } from "../../../../../utils/get-formatted-date"
import { getFormattedTimePeriod } from "../../../../../utils/get-formatted-time"
import { useBreakpoints } from "../../../../../utils/use-breakpoints"
import { Route } from "../$id"
import { CastsTab } from "../-components/-tabs/CastsTab"
import { StartTab } from "../-components/-tabs/start-tab"
import { ActivityTypeText } from "../-components/activity-type-text"

const navOpts = { replace: true }
export function ActivityTabs() {
  const searchParams = new URLSearchParams(window.location.search)
  const detailOpened = searchParams.get("reminderDetailOpened") === "true"
  const reminderId = searchParams.get("reminderId")
  const [detailModalOpen, setDetailModalOpen] = useState(detailOpened)
  const { data: selectedReminder, isLoading: loadingReminder } = useQueryGet(
    "/api/Reminder/GetReminderById",
    reminderId ? { reminderId: Number(reminderId) } : ({} as any),
    {
      enabled: !!detailOpened && !!reminderId,
    }
  )

  useEffect(() => {
    setDetailModalOpen(detailOpened)
  }, [detailOpened])
  const { t } = useTranslation("app_server")
  const navigate = Route.useNavigate()
  const { tab } = Route.useSearch()
  const activityId = parseInt(Route.useParams().id)
  const search = Route.useSearch()

  const { data: activityDetails } = useSuspenseQueryGet(
    "/api/Activity/GetActivity",
    {
      activityId,
    }
  )

  const router = useRouter()
  React.useEffect(() => {
    router.invalidate()
  }, [])
  const { menuItem: newReminderMenuItemProps, modal: reminderInputModal } =
    useGetNewReminderMenuItemProps()
  const { menuItem: reminderListMenuItemProps, modal: reminderListModal } =
    useGetReminderListMenuItemProps()

  return (
    <ReminderPageWrapper
      reminderId={reminderId}
      detailOpened={detailModalOpen}
      onClose={() => {
        setDetailModalOpen(false)
        const params = new URLSearchParams(window.location.search)
        params.delete("reminderDetailOpened")
        params.delete("reminderId")
        window.history.replaceState(null, "", `?${params.toString()}`)
      }}
    >
      <Page
        crumbOverride={() => (
          <ActitivityTitleText fz="xl" fw={"bold"} activityId={activityId} />
        )}
        dottedMenuProps={{
          items: [newReminderMenuItemProps, reminderListMenuItemProps],
        }}
      >
        <DetailsTabs
          onChange={(tab) =>
            navigate({ ...navOpts, search: { ...search, tab: tab } })
          }
          value={tab}
          tabs={[
            {
              value: "start",
              label: t("Start"),
              content: <StartTab activity={activityDetails} />,
            },
            {
              value: "casts",
              label: t("Casts"),
              content: <CastsTab activityId={activityId} />,
            },
          ]}
        />
        {reminderInputModal}
        {reminderListModal}
      </Page>
    </ReminderPageWrapper>
  )
}
function ActitivityTitleText({
  activityId,
  ...props
}: { activityId: number } & TextProps) {
  const { data: activity } = useSuspenseQueryGet("/api/Activity/GetActivity", {
    activityId,
  })
  const { xs } = useBreakpoints()
  return (
    <Text {...props}>
      <Text span inherit>
        {getFormattedDate(activity?.date as DateOnly, xs ? "L " : "ddd L")}
      </Text>{" "}
      <Text span inherit>
        {activity?.timePeriod.start && xs
          ? dateToTimeOnly(new Date(activity.timePeriod.start))
          : getFormattedTimePeriod(activity?.timePeriod)}
      </Text>{" "}
      <ActivityTypeText
        span
        inherit
        name={xs ? activity.activityType.shortName : activity.activityType.name}
        foreColor={activity.activityType.foreColor}
        backColor={activity.activityType.backColor}
        rehearseNumber={activity.rehearseNumber}
      />{" "}
      <ProductionTitleText inherit span productionTitle={activity?.title} />{" "}
      <Text span inherit>
        {xs ? activity.locationShort : activity.location}
      </Text>
    </Text>
  )
}
